import { Skeleton } from '@/components/ui/skeleton'

const NegotiationMessagesSkeleton: React.FC = () => {
  return (
    <div className="overflow-auto flex-1 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:'none'] [scrollbar-width:'none']">
      <div className='flex mb-4 justify-end'>
        <div className='max-w-[80%] p-4 rounded-[20px] bg-[#E6ECF1] text-right'>
          <div className='space-y-2'>
            <Skeleton className='h-4 w-full' />
            <Skeleton className='h-4 w-full' />
            <Skeleton className='h-4 w-5/6' />
          </div>
        </div>
      </div>

      <div className='flex mb-4 justify-start'>
        <div className='max-w-[80%] p-4 rounded-[20px] bg-[#E6ECF1] text-left'>
          <div className='flex items-center gap-3 mb-2'>
            <Skeleton className='w-8 h-8 rounded-full' />
            <div className='flex flex-col'>
              <Skeleton className='h-4 w-32' />
              <Skeleton className='h-3 w-20 mt-1' />
            </div>
          </div>
          <div className='space-y-2'>
            <Skeleton className='h-4 w-full' />
            <Skeleton className='h-4 w-4/5' />
            <Skeleton className='h-4 w-2/3' />
          </div>
        </div>
      </div>

      <div className='flex mb-4 justify-start'>
        <div className='max-w-[80%] p-4 rounded-[20px] bg-[#E6ECF1] text-left'>
          <div className='flex items-center gap-3 mb-2'>
            <Skeleton className='w-8 h-8 rounded-full' />
            <div className='flex flex-col'>
              <div className='flex items-center'>
                <Skeleton className='h-4 w-28 mr-2' />
                <Skeleton className='h-5 w-16 rounded-md' />
              </div>
            </div>
          </div>
          <div className='space-y-2'>
            <Skeleton className='h-4 w-full' />
            <Skeleton className='h-4 w-5/6' />
            <Skeleton className='h-4 w-3/4' />
          </div>
        </div>
      </div>

      <div className='flex mb-4 justify-end'>
        <div className='max-w-[80%] p-4 rounded-[20px] bg-[#E6ECF1] text-right'>
          <div className='space-y-2'>
            <Skeleton className='h-4 w-full' />
            <Skeleton className='h-4 w-full' />
            <Skeleton className='h-4 w-4/5' />
          </div>
        </div>
      </div>

      <div className='flex mb-4 justify-start'>
        <div className='max-w-[80%] p-4 rounded-[20px] bg-[#E6ECF1] text-left'>
          <div className='flex items-center gap-3 mb-2'>
            <Skeleton className='w-8 h-8 rounded-full' />
            <div className='flex flex-col'>
              <Skeleton className='h-4 w-24' />
              <Skeleton className='h-3 w-16 mt-1' />
            </div>
          </div>
          <div className='space-y-2'>
            <Skeleton className='h-4 w-full' />
            <Skeleton className='h-4 w-3/5' />
          </div>
        </div>
      </div>
    </div>
  )
}

export default NegotiationMessagesSkeleton
